import React from 'react';
import AdminSidebar from './AdminSidebar';

function AdminLayout({ children, activeSection }) {
  const [mobileMenuOpen, setMobileMenuOpen] = React.useState(false);
  return (
    <div className="min-h-screen relative" style={{
      backgroundImage: 'url("/gage road.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundAttachment: 'fixed'
    }}>
      {/* Logo - positioned on background */}
      <div className="absolute top-4 right-4 z-10">
        <div className="bg-white rounded-3xl px-6 py-4 shadow-lg">
          <img
            src="/logo.png"
            alt="Logo"
            className="h-14 w-auto"
          />
        </div>
      </div>

      {/* Main Container with padding */}
      <div className="min-h-screen p-6">
        <div className="relative h-[calc(100vh-48px)] rounded-[2rem] overflow-hidden shadow-2xl bg-white">
          {/* Wave pattern background */}
          <div className="absolute inset-0 hidden md:block">
            {/* Use a viewBox so the wave and sidebar align by percentage, avoiding zoom clipping */}
            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1000 1000" preserveAspectRatio="none">
              <defs>
                <mask id="waveMask">
                  <rect x="0" y="0" width="100%" height="100%" fill="white" />
                  <path
                    d="M 155 0
                       Q 141.66 41.67, 155 83.33
                       T 155 166.67
                       Q 141.66 208.33, 155 250
                       T 155 333.33
                       Q 141.66 375, 155 416.67
                       T 155 500
                       Q 141.66 541.67, 155 583.33
                       T 155 666.67
                       Q 141.66 708.33, 155 750
                       T 155 833.33
                       Q 141.66 875, 155 916.67
                       T 155 1000
                       L 0 1000
                       L 0 0
                       Z"
                    fill="black"
                    transform="scale(1, 1)"
                  />
                </mask>
              </defs>
              
              {/* Base fill to avoid sub-pixel seams showing white */}
              <rect x="0" y="0" width="100%" height="100%" fill="#1e4b45" />

              {/* Dark green sidebar with slight overlap under wave */}
              <rect x="0" y="0" width="18%" height="100%" fill="#133634" />
              
              {/* Light teal main area with wave edge */}
              <rect x="0" y="0" width="100%" height="100%" fill="#1e4b45" mask="url(#waveMask)" />
            </svg>
          </div>

          {/* Mobile top bar with menu button */}
          <div className="relative md:hidden z-10 flex items-center justify-between px-4 py-3">
            <button
              type="button"
              aria-label="Open menu"
              onClick={() => setMobileMenuOpen(true)}
              className="inline-flex items-center justify-center rounded-xl border border-gray-300 bg-white/90 px-3 py-2 shadow-sm text-gray-800"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

          <div className="relative grid grid-cols-12 h-full overflow-hidden">
            {/* Sidebar (desktop only) */}
            <AdminSidebar activeSection={activeSection} />

            {/* Main Content */}
            <div className="col-span-12 md:col-span-10 p-6 md:p-12 h-full overflow-y-auto">
              {children}
            </div>
          </div>

          {/* Mobile drawer */}
          {mobileMenuOpen && (
            <>
              <div
                className="fixed inset-0 z-40 bg-black/40"
                onClick={() => setMobileMenuOpen(false)}
              />
              <div className="fixed inset-y-0 left-0 z-50 w-72 bg-[#133634] text-white shadow-2xl rounded-r-2xl overflow-y-auto">
                <div className="flex items-center justify-between px-4 py-3 border-b border-white/20">
                  <span className="text-sm font-medium">Menu</span>
                  <button
                    type="button"
                    aria-label="Close menu"
                    onClick={() => setMobileMenuOpen(false)}
                    className="inline-flex items-center justify-center rounded-lg p-2 text-white hover:bg-white/10"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>
                <div className="p-4">
                  <AdminSidebar activeSection={activeSection} variant="drawer" />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AdminLayout;
